module.exports = function (path) {
    window.iframePaths = window.iframePaths || [];
    window.iframePaths.push(path);
    var uri = new URI(path);
    var pathname = uri.pathname();
    history.pushState({}, '', pathname);
};